// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__aOKux"};